import type { components } from '@joyful/openapi/types.gen'
import { createEnumSchema } from '@joyful/utils'

export const EncounterUpdateViolationCodeSchema = createEnumSchema<
  components['schemas']['EncounterUpdateViolationCode']
>([
  { title: 'Already snoozed', value: 'already_snoozed' },
  { title: 'Belongs to another account', value: 'belongs_to_account' },
  { title: 'Not found', value: 'not_found' },
  {
    title: 'Requires an assigned biller to you',
    value: 'requires_assigned_to_you_for_override',
  },
  {
    title: 'Requires an assignment for snooze',
    value: 'requires_assignment_for_snooze',
  },
  { title: 'Requires follow-up flag', value: 'requires_followup_flag' },
  {
    title: 'Requires a follow-up flag for override',
    value: 'requires_followup_flag_for_override',
  },
  {
    title: 'Requires an unassigned biller',
    value: 'requires_unassigned_biller',
  },
  {
    title: 'Requires a workflow status of new or none',
    value: 'requires_workflow_status_new_or_none',
  },
  { title: 'Can only be assigned to yourself', value: 'self_assign_only' },
  { title: 'Snooze date is in the past', value: 'snooze_date_in_past' },
  {
    title: 'Encounter is closed',
    value: 'snooze_encounter_closed',
  },
  {
    title: 'Encounter is resolved',
    value: 'snooze_encounter_resolved',
  },
  {
    title: 'Snooze date exceeds filing limit',
    value: 'snooze_exceeds_filing_limit',
  },
  {
    title: 'Must be flagged for follow-up to snooze',
    value: 'snooze_requires_followup_flag',
  },
])
